<div
  class="position-absolute bottom-20 end-5 z-1"
  *ngIf="
    isOneWarningLayerVisible() ||
    isOneProvider1LayerVisible() ||
    isOneProvider2LayerVisible() ||
    isOneProvider3LayerVisible() ||
    isOneProvider4LayerVisible() ||
    isOneProvider6LayerVisible() ||
    isOneProvider7LayerVisible() ||
    isOneProvider8LayerVisible() ||
    isOneProvider9LayerVisible()
  "
>
  <app-legend>
    <app-legend-category
      *ngIf="isOneWarningLayerVisible()"
      name="Road Hazard"
      [metric]="obstacleMetric()"
    ></app-legend-category>
    <ng-container *ngIf="providerInfo$() | async as providers">
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider1LayerVisible()"
        [name]="providers.provider"
        [metric]="provider1Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider2LayerVisible()"
        [name]="providers.provider2"
        [metric]="provider2Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider3LayerVisible()"
        [name]="providers.provider3"
        [metric]="provider3Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider4LayerVisible()"
        [name]="providers.provider4"
        [metric]="provider4Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider6LayerVisible()"
        [name]="providers.provider6"
        [metric]="provider6Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider7LayerVisible()"
        [name]="providers.provider7"
        [metric]="provider7Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider8LayerVisible()"
        [name]="providers.provider8"
        [metric]="provider8Metric()"
      ></app-legend-category>
      <app-legend-category
        isDemoEnabled
        *ngIf="isOneProvider9LayerVisible()"
        [name]="providers.provider9"
        [metric]="provider9Metric()"
      ></app-legend-category>
    </ng-container>
  </app-legend>
</div>
